import { ScopedRequestRole, ScopedRequestType } from 'lib/generated/graphql';

export const TEMPLATE_TYPES = {
  'ZERO_TO_ONE_LAUNCH': 'ZERO_TO_ONE_LAUNCH',
  'NEW_PRODUCT_FEATURE': 'NEW_PRODUCT_FEATURE',
  'REBRAND': 'REBRAND',
  'PITCH_DECK': 'PITCH_DECK',
  'MARKETING_WEBSITE': 'MARKETING_WEBSITE',
};

export const TEMPLATES = {
  [TEMPLATE_TYPES.ZERO_TO_ONE_LAUNCH]: {
    title: '0-to-1 Startup Launch',
    scope: `Excited to share that I’m launching a new venture called COMPANYNAME. We’re still in the early days and looking for a team to help us get started.

Specifically looking to get…
A lightweight brand that we can launch with, including a name, logo and visual identity
Simple marketing website to collect emails 
Strong product partner to think through the MVP experience
Product design for the MVP with a clickable prototype`
  },
  [TEMPLATE_TYPES.NEW_PRODUCT_FEATURE]: {
    title: 'New Product Feature',
    scope: `We’d like to partner with a product team to help us launch a new feature on our app.

{Add more information about the feature here!}

Specifically looking for a team to...
Create a beautiful UX
Ship the feature with 1-2 full-stack developers`
  },
  [TEMPLATE_TYPES.REBRAND]: {
    title: 'Rebrand',
    scope: `We’re looking for a product and brand design huddle to help us launch a new identity for COMPANYNAME.

Specifically looking to...
Get a new logo
Redesign our website (www.website.com) with the new brand
Create a set of marketing assets to span across our social profiles and for marketing the rebrand
Produce brand guidelines that can be applied across our app and other key touchpoints`
  },
  [TEMPLATE_TYPES.PITCH_DECK]: {
    title: 'Pitch Deck',
    scope: `We’re looking for help creating and designing a pitch deck for COMPANYNAME’s current fundraise.

Specifically looking to get…
A compelling narrative together
Strong copywriting to tell our story
10-15 slides designed`
  },
  [TEMPLATE_TYPES.MARKETING_WEBSITE]: {
    title: 'Marketing Website',
    scope: `We’re looking to design and launch a new high-converting marketing website for COMPANYNAME.

Specifically looking to get…
Thoughtful UX that will boost our website conversions
Product designs across a 4-6-page website, including a landing page, two detail pages, a contact page and signup/login pages
Front-end development of the website on Webflow or Framer.`
  },
};

export const SCOPE_PLACEHOLDER  = `We’re looking for a product and brand design team to help us launch a new identity across our marketing website and mobile app by the end of this quarter.
\n\nSpecifically looking to get...
- A new logo and updated brand guidelines
- New marketing website`;

export const ROLES = {
  [ScopedRequestRole.ProductDesign]: {
    title: 'Product Design',
  },
  [ScopedRequestRole.SoftwareDevelopment]: {
    title: 'Software Development',
  },
  [ScopedRequestRole.BrandVisualDesign]: {
    title: 'Brand / Visual Design',
  },
  [ScopedRequestRole.MarketingGrowth]: {
    title: 'Marketing / Growth',
  },
};
